// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__CGnnY","mulShdSpin":"loader_mulShdSpin__MAjVA","loaderPoint":"loader_loaderPoint__feHTd","flash":"loader_flash__2eHfa"};